import type { CompanyContent } from '../schema';

export const companyContent = {
  contactDetails: [
    {
      id: 'phone',
      icon: 'phone',
      content: '+91 88704 35979',
      href: 'tel:+918870435979',
      label: 'Call us: +91 88704 35979',
    },
    {
      id: 'email',
      icon: 'mail',
      content: 'info@sreesilks.com',
      href: 'mailto:info@sreesilks.com',
      label: 'Email us: info@sreesilks.com',
    },
    {
      id: 'address',
      icon: 'map-pin',
      content: 'Palanivel Chetty St, Jalakandapuram, Tamil Nadu 636501',
    },
  ],
  socialLinks: [
    {
      id: 'instagram',
      name: 'Instagram',
      href: 'https://instagram.com/sssreesilks',
      icon: 'instagram',
      ariaLabel: 'Visit our Instagram profile',
    },
    {
      id: 'facebook',
      name: 'Facebook',
      href: 'https://www.facebook.com/sssreesilks',
      icon: 'facebook',
      ariaLabel: 'Visit our Facebook page',
    },
    {
      id: 'whatsapp',
      name: 'Whatsapp',
      href: 'https://api.whatsapp.com/send?phone=918870435979&text=Heyy!',
      icon: 'whatsapp',
      ariaLabel: 'Chat with us on WhatsApp',
    },
  ],
} satisfies CompanyContent;
